import React from 'react';
import { Box, Button, Chip } from '@mui/material';
import { Close, Delete } from '@mui/icons-material';

/**
 * Reusable Bulk Action Bar Component
 * Appears as a fixed bar at the bottom when items are selected
 *
 * @param {number} selectedCount - Number of selected items
 * @param {function} onClearSelection - Callback to clear selection
 * @param {function} onDelete - Callback when delete is clicked
 */
const BulkActionBar = ({ selectedCount, onClearSelection, onDelete }) => {
  if (selectedCount === 0) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 24,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 1300,
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        bgcolor: '#875A7B',
        borderRadius: '8px',
        px: 2,
        py: 1,
        boxShadow: '0 8px 32px rgba(0,0,0,0.25)',
      }}
    >
      <Chip
        label={`${selectedCount} selected`}
        onDelete={onClearSelection}
        deleteIcon={<Close sx={{ fontSize: 16, color: '#fff !important' }} />}
        sx={{
          bgcolor: 'rgba(255,255,255,0.2)',
          color: '#fff',
          fontWeight: 600,
          fontSize: '13px',
          '& .MuiChip-deleteIcon:hover': { color: '#fff !important' },
        }}
      />
      <Button
        size="small"
        startIcon={<Delete sx={{ fontSize: 18 }} />}
        onClick={onDelete}
        sx={{
          color: '#fff',
          textTransform: 'none',
          fontSize: '13px',
          fontWeight: 500,
          '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' },
        }}
      >
        Delete
      </Button>
    </Box>
  );
};

export default BulkActionBar;
